import {getDefaultLocaleByAppLanguage, LocaleProvider} from 'platform/locale';

import {Provider} from 'react-redux';
import {MemoryRouter} from 'react-router-dom';

import {fileStorageApi, metadaApi, omneticApi} from '@dms/api/base';
import {cachedApi} from '@dms/api/core';

import {ComponentChildren, createTestStore} from 'shared/web';

import {InitializeMockData} from '../../utils/InitializeMockData';
import {ProvidersConfig} from './ProvidersConfig';

type MockProviderProps = ComponentChildren & ProvidersConfig;

const reducers = [omneticApi, cachedApi, metadaApi, fileStorageApi];

export const HookMockProvider = (props: MockProviderProps) => (
  <MemoryRouter {...props.memoryRouterProps}>
    <Provider store={createTestStore(reducers)}>
      <LocaleProvider
        language={props.language || 'en'}
        config={getDefaultLocaleByAppLanguage(props.language || 'en')}
      >
        <InitializeMockData>{props.children}</InitializeMockData>
      </LocaleProvider>
    </Provider>
  </MemoryRouter>
);
